import { AMC } from '@/services';
import { createContext, useContext, ReactNode } from 'react';

interface AMCContextType {
  amcId: string | undefined;
  amc: AMC | null;
}

const AMCContext = createContext<AMCContextType | undefined>(undefined);

export function AMCProvider({
  children,
  amcId,
  amc,
}: {
  children: ReactNode;
  amcId: string | undefined;
  amc: AMC | null;
}) {
  return <AMCContext.Provider value={{ amcId, amc }}>{children}</AMCContext.Provider>;
}

export function useAMC() {
  const context = useContext(AMCContext);
  if (context === undefined) {
    throw new Error('useAMC must be used within an AMCProvider');
  }
  return context;
}
